import React from 'react';
import { useParams } from 'react-router-dom';
import { type ChiefSupervisorFromValues, type ApplicationInfo } from './type';
import { ChiefSupervisorBox } from './ChiefSupervisorBox';
import { type SupervisorValue, useGetChiefSupervisors } from '../../../graphql';
import { Alert, Loading, type SelectOption } from '../../../../../components';
import { useAuth } from '../../../../../contexts';
import { useGetSupervisorLDAP } from '../../../graphql/NominationForm/Supervisors/useGetSupervisorLDAP';
import type { NominationModules } from '../../../constants';

type ChiefSupervisorBoxProps = {
  applicationInfo: ApplicationInfo;
  chiefSupervisor?: string;
  isViewMode: boolean;
  refetchNominationInformation: () => void;
  onMoveNext: (activatedId: NominationModules) => void;
};

export const ChiefSupervisorContent: React.FunctionComponent<
  ChiefSupervisorBoxProps
> = props => {
  const {
    applicationInfo,
    isViewMode,
    onMoveNext,
    refetchNominationInformation,
  } = props;
  const { nominationId } = useParams();
  let departmentOpt: SelectOption[] = [];
  const hasNominationId = Boolean(nominationId);
  let loading = false;

  const { user } = useAuth();

  let chiefSupervisor: ChiefSupervisorFromValues = {
    netId: user?.sub ?? 'USER NETID PLACEHOLDER',
    institution: '',
    title: '',
    jobTitle: '',
    givenName: '',
    surname: '',
    department: '',
    email: '',
    previousSuccessfulSupervision: false,
    isDrcChair: false,
    isDoRPgS: false,
  };
  let refetchChiefSupervisor = (): void => {};
  let coSupervisors: SupervisorValue[] = [];
  if (hasNominationId) {
    // get chief supervisor from nomination database
    const {
      chiefSupervisor: supervisorInfo,
      coSupervisors: coSupervisorsData,
      loading: loadSupervisor,
      departmentOptions,
      error,
      refetch,
    } = useGetChiefSupervisors(nominationId as string);
    coSupervisors = coSupervisorsData;
    departmentOpt = departmentOptions;
    loading = loadSupervisor;
    refetchChiefSupervisor = refetch;
    const { netId, ...others } = supervisorInfo;
    chiefSupervisor = { ...others, netId: netId ?? user?.sub ?? '' };

    if (error)
      return (
        <Alert
          openAlert
          setOpenAlert={() => {}}
          alertDetails={{
            alertContent: 'Error Occurs.' + (error as Error)?.message,
            alertType: 'error',
          }}
        />
      );
  } else {
    // get chief supervisor from initial supervisor store
    const {
      chiefSupervisor: supervisorInfo,
      loading: loadSupervisor,
      departmentOptions,
      error,
    } = useGetSupervisorLDAP(user?.sub as string);
    departmentOpt = departmentOptions;

    loading = loadSupervisor;
    if (supervisorInfo !== undefined && supervisorInfo != null) {
      const { netId, ...others } = supervisorInfo;
      chiefSupervisor = { ...others, netId: netId ?? user?.sub ?? '' };
    }
    if (error)
      return (
        <Alert
          openAlert={true}
          setOpenAlert={() => {}}
          alertDetails={{
            alertContent: 'Error Occurs.' + (error as Error)?.message,
            alertType: 'error',
          }}
        />
      );
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <ChiefSupervisorBox
          isViewMode={isViewMode}
          coSupervisors={coSupervisors}
          supervisorData={chiefSupervisor}
          applicationInfo={applicationInfo}
          departmentOptions={departmentOpt}
          onMoveNext={onMoveNext}
          refetchNominationInformation={() => {
            refetchNominationInformation();
            refetchChiefSupervisor();
          }}
        />
      )}
    </>
  );
};
